import { api } from "@/lib/api";

export const G = "/guest-contacts";

export const CONSENT_TONE = {
  OPTED_IN: "bg-emerald-100 text-emerald-800 border-emerald-300",
  OPTED_OUT: "bg-red-100 text-red-800 border-red-300",
  UNKNOWN: "bg-slate-100 text-slate-700 border-slate-300",
};

export const ROW_TONE = {
  NEW: "bg-emerald-100 text-emerald-800",
  UPDATE_FILL: "bg-sky-100 text-sky-800",
  UNCHANGED: "bg-slate-100 text-slate-600",
  CONFLICT: "bg-amber-100 text-amber-900",
  NEEDS_CONFIRMATION: "bg-orange-100 text-orange-900",
  DUPLICATE_IN_FILE: "bg-violet-100 text-violet-800",
  INVALID: "bg-red-100 text-red-800",
};

export const ROW_LABEL = {
  NEW: "New", UPDATE_FILL: "Adds missing details", UNCHANGED: "Already exists",
  CONFLICT: "Conflict — review", NEEDS_CONFIRMATION: "Confirm phone",
  DUPLICATE_IN_FILE: "Duplicate in file", INVALID: "Invalid",
};

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Request failed";
  if (typeof d === "string") return d;
  return d.message || JSON.stringify(d);
};

export async function download(path, body, filename) {
  const r = await api.post(path, body, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url; a.download = filename; a.click();
  URL.revokeObjectURL(url);
}
